module.exports = __webpack_public_path__ + "static/media/left-arrow.e40fc219.svg";